// Karibik — badge de precio dinámico al cambiar variante en PDP
(function () {

    function formatMoneyCOP(cents) {
    return '$' + (cents / 100).toLocaleString('es-CO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updateKaribikBadge(variant) {
    const badge = document.querySelector('[data-karibik-badge]');
    if (!badge) return;

    const type = badge.dataset.discountType;
    let originalPrice, promoPrice, discPct;

    switch (type) {
            case 'rebajas_bazar':
        // Tachado = precio real; franja roja = 50% del precio real
        originalPrice = variant.price;
        promoPrice    = Math.round(variant.price * 0.5);
        discPct       = 50;
        break;

      case 'rebajas':
        if (!variant.compare_at_price || variant.compare_at_price <= variant.price) return;
        originalPrice = variant.compare_at_price;
        promoPrice    = variant.price;
        discPct       = Math.round(((originalPrice - promoPrice) / originalPrice) * 100);
        break;

      case 'hotsale':
        originalPrice = variant.price;
        promoPrice    = Math.round(variant.price * 0.8);
        discPct       = 20;
        break;

      case 'compare':
        if (!variant.compare_at_price || variant.compare_at_price <= variant.price) return;
        originalPrice = variant.compare_at_price;
        promoPrice    = variant.price;
        discPct       = Math.round(((originalPrice - promoPrice) / originalPrice) * 100);
        break;

      default:
        return;
    }

    // Actualizar precio tachado
    const originalEl = document.querySelector('[data-karibik-original]');
    if (originalEl) {
      originalEl.textContent = formatMoneyCOP(originalPrice);
      originalEl.dataset.karibikOriginal = originalPrice;
    }

    // Actualizar badge
    badge.querySelector('.karibik-price-badge__discount').textContent = `-${discPct}%`;
    badge.querySelector('.karibik-price-badge__price').textContent    = formatMoneyCOP(promoPrice);
  }

  // Eventos de cambio de variante (Dawn y compatibles)
  document.addEventListener('variant:changed',  e => e.detail?.variant && updateKaribikBadge(e.detail.variant));
  document.addEventListener('variantChange',     e => e.detail?.variant && updateKaribikBadge(e.detail.variant));

})();